/**
 * FormatSelector - Seletor de formato de exportação
 */

import { MODAL_STYLES, EXPORT_FORMATS, EXPORT_FORMAT_DESCRIPTIONS } from '../constants';
import type { ExportFormat } from '../types';

interface FormatSelectorProps {
  value: ExportFormat;
  onChange: (format: ExportFormat) => void;
  recommendedFormat: ExportFormat | null;
  disabled?: boolean;
}

export function FormatSelector({ value, onChange, recommendedFormat, disabled }: FormatSelectorProps) {
  const isRecommended = recommendedFormat && value === recommendedFormat;
  
  return (
    <div className="space-y-2">
      <label className="text-xs font-medium text-gray-300">Formato de exportação</label>
      
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as ExportFormat)}
        disabled={disabled}
        className={MODAL_STYLES.select}
        aria-label="Selecionar formato de exportação"
      >
        {Object.entries(EXPORT_FORMATS).map(([key, label]) => (
          <option key={key} value={key}>
            {label}
            {recommendedFormat === key ? ' (recomendado)' : ''}
          </option>
        ))}
      </select>
      
      {isRecommended && (
        <div className="flex items-center gap-2 text-xs text-gray-400">
          <span className="text-yellow-400">✓</span>
          <span>Formato recomendado para este produto</span>
        </div>
      )}
      
      <div className="text-xs text-gray-500">
        {EXPORT_FORMAT_DESCRIPTIONS[value]}
      </div>
    </div>
  );
}

